import React, { useState } from "react";
import { Form, Input, Button, message, Space } from "antd";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { BASE_URL } from "../config";
import LanguageSwitcher from './LanguageSwitcher';
import notificationService from '../services/NotificationService';

interface LoginProps {
  onLoginSuccess: (token: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const { t } = useTranslation();

  const handleLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    
    try {
      const response = await axios.post<{ token: string }>(`${BASE_URL}/login`, values);
      
      const { token } = response.data;
      localStorage.setItem("token", token);
      
      onLoginSuccess(token);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 401) {
          messageApi.error(t('login.invalidCredentials'));
        } else {
          messageApi.error(t('login.loginError', { error: err.response?.data?.message || err.message }));
        }
      } else {
        messageApi.error(t('login.loginFailed'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minWidth: 300, margin: "160px auto", position: 'relative' }}>
      {contextHolder}
      <div style={{ position: 'absolute', top: -60, right: 0 }}>
        <LanguageSwitcher />
      </div>
      <h2 style={{ textAlign: 'center', marginBottom: "24px" }}>{t('login.title')}</h2>
      <Form onFinish={handleLogin}>
        <Form.Item 
          name="username" 
          rules={[{ required: true, message: t('login.usernameRequired') }]}
        >
          <Input placeholder={t('login.username')} />
        </Form.Item>
        <Form.Item 
          name="password" 
          rules={[{ required: true, message: t('login.passwordRequired') }]}
        >
          <Input.Password placeholder={t('login.password')} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            {t('login.loginButton')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;